import type { PropType } from 'vue'
import { ExtractPropTypes } from 'vue'

export const helpProps = {
  maxWidth: {
    type: String as PropType<string>,
    default: '600px',
  },
  showIndex: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String as PropType<string>,
    default: '',
  },
  fontSize: { type: String, default: '14px' },
  placement: { type: String, default: 'right' },
  text: { type: [Array, String] as PropType<string[] | string> },
} as const

export type HelpProps = ExtractPropTypes<typeof helpProps>
